const initial = {
    searchCriteriaList: [
      { key: "batchNo", value: undefined },
      { key: "sampleSentDate", value: "" },
      { key: "receivedDate", value: "" },
      { key: "stateIds", value: [null] },
      { key: "categoryId", value: ""},
      { key: "lotNo", value: undefined }
    ],
  };
  export default (state = initial, event) => {
    switch (event.type) {
      case "UPDATE_FILTER":
        return {
          ...state,
          searchCriteriaList: [...event.data],
        };
  
      default:
        return state;
    }
  };
  